module.exports = {
      id: "green-tick-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#green-tick",
      toString: function () {
        return this.url;
      }
    }